export default __webpack_public_path__ + "static/media/nitrofx.127c05d6.png";